import { Box, Modal, Stack, SxProps, TextField, Theme } from "@mui/material";
import { useState } from "react";
import type { CustomProps } from "../../components/general/types/Modify";
import { getValidationProps } from "../../helpers/control-helpers";
import { useTagGroup } from "../../hooks/tags/queries/useTagGroup";
import { caseStrings as strings } from "../../resources/strings/cases";
import { api } from "../../services/reports.service";
import type { CaseData } from "../../types/documents";
import { Button } from "../general/Button";
import { Dropdown } from "../general/controls/Dropdown";

const dropdownStyles: SxProps<Theme> = {
  width: "100%",
};

interface Props extends CustomProps<CaseData> {}
type Component = (props: Props) => JSX.Element;

export const ProjectsDropdown: Component = (props) => {
  const { handleChange, data, mode } = props;

  const selectedValue = Array.isArray(data.project)
    ? data.project
    : data.project
    ? [data.project]
    : [];

  const [, , refetch] = useTagGroup([], "projects");

  const [showModal, setShowModal] = useState(false);
  const [newProject, setNewProject] = useState("");
  const [error, setError] = useState("");

  const handleAddProject = async () => {
    if (newProject.trim()) {
      try {
        await api.addProject(newProject);
        setShowModal(false);
        setNewProject("");
        refetch();
      } catch (e: any) {
        setError(e);
      }
    }
  };

  return (
    <>
      <Stack direction="row" gap={2}>
        <Box sx={dropdownStyles}>
          <Dropdown<CaseData>
            config={{
              name: "project",
              label: strings.labels.project,
              required: true,
              disabled: mode === "view",
              SelectProps: {
                multiple: true,
              },
              value: selectedValue,
              tagConfig: { tagGroup: "projects" },
              other: {
                name: "projectOther",
                label: strings.labels.projectOther,
                value: data.projectOther,
              },
              ...getValidationProps("project", props.validationResults),
            }}
            handleChange={handleChange}
          />
        </Box>

        {mode !== "view" && (
          <Button
            variant="contained"
            onClick={() => setShowModal(true)}
            label={strings.labels.addProject}
            sx={{ mx: 0, height: "100%" }}
          />
        )}
      </Stack>

      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <TextField
            label={strings.labels.newProject}
            fullWidth
            value={newProject}
            onChange={(e) => {
              setNewProject(e.target.value);
              setError("");
            }}
            error={Boolean(error)}
            helperText={error}
          />
          <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleAddProject}
              label={strings.labels.add}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};
